import { get } from 'svelte/store';
import { ApiTypes } from '../../enums/api.enum';
import {
  addApiError,
  addBusyApi,
  removeBusyApi,
} from '../../helpers/handle-api';
import type { IRequestSearch } from '../../interfaces/request-search-question.interface';
import { ConfigStore } from '../../store/config';
import { state_apiErrors } from '../../store/state';
import { defaultLogger as logger } from '../../telemetry/logger';
import { trackedFetch } from '../../telemetry/tracked-fetch';
import { UserStateHelper } from '../../helpers/user-state-helper';

/** function to fetch GET /1/question api end point */
export async function postQuestionStream(
  params: IRequestSearch,
  signal: AbortSignal,
  wasRetried: boolean = false
): Promise<any> {
  try {
    let url;
    if (params.requestType === 'greeting') {
      url = new URL(`${get(ConfigStore).apiBaseUrl}/1/greeting?stream=true`);
    } else {
      url = new URL(`${get(ConfigStore).apiBaseUrl}/1/question?stream=true`);
      logger.debug('Request Type: ', params.requestType);
      logger.debug('Cache Message?: ', get(ConfigStore)?.cacheMsg);
      if (
        params.requestType &&
        get(ConfigStore)?.cacheMsg?.includes(params.requestType)
      ) {
        url.searchParams.set('cache', 'true');
      }
    }
    params.requestType = undefined;

    if (!!get(ConfigStore)?.serverConfig?.tenant_id)
      url.searchParams.set('tenant', get(ConfigStore)?.serverConfig?.tenant_id ?? "");

    if (get(ConfigStore)?.serverConfig?.id)
      params.config = get(ConfigStore)?.serverConfig?.id;

    UserStateHelper.setRequestProperties(params);

    //addBusyApi(ApiTypes.streamPOSTQuestion);
    state_apiErrors.set(
      get(state_apiErrors).filter(
        (x) => x.apiType !== ApiTypes.streamPOSTQuestion
      )
    );

    return trackedFetch(get(ConfigStore)?.serverConfig?.tenant_id ?? "", url.href, {
      method: 'POST',
      cache: 'no-cache',
      keepalive: true,
      signal,
      headers: {
        'Content-Type': 'application/json',
        // "Accept": "text/event-stream",
      },
      body: JSON.stringify(params),
    })
      .then((res) => {
        if (res?.ok) return res;
        throw res;
      })
      .catch(async (res) => {
        if (res?.status === 404 && !wasRetried) {
          return new Promise((resolve) =>
            setTimeout(async () => {
              logger.info('Retrying streaming POST /1/question after 404');
              const value = await postQuestionStream(params, signal, true);
              resolve(value);
            }, 500)
          );
        } else {
          removeBusyApi(ApiTypes.streamPOSTQuestion);
          let body: any;
          if (res?.response) {
            try {
              body = await res.response.clone().json();
            } catch {
              body = undefined;
            }
          }
          /** error api */
          addApiError({
            apiType: ApiTypes.streamPOSTQuestion,
            status: res?.status,
            statusText: res?.statusText,
            error: body?.error ?? 'no message',
            message: body?.message,
            noticeCode: body?.notice_code,
            noticeReason: body?.notice_reason,
            errorType: res?.type || res?.name,
          });

          throw res;
        }
      })
      .finally(() => {
        //removeBusyApi(ApiTypes.streamPOSTQuestion);
      });
  } catch (e) {
    //removeBusyApi(ApiTypes.streamPOSTQuestion);
    throw e;
  }
}
